import { render, staticRenderFns } from "./JoinedSuccess.vue?vue&type=template&id=6ab8e688&"
import script from "./JoinedSuccess.vue?vue&type=script&lang=js&"
export * from "./JoinedSuccess.vue?vue&type=script&lang=js&"
import style0 from "./JoinedSuccess.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports